// =============================================================================
// SIREPPAR - "¿El trámite ya fue iniciado?"
// =============================================================================
// Espejo de la guarda del backend (services/tramiteIniciado.ts). Un expediente en
// BORRADOR (el wizard externo no terminó) o PRESENTADO (está en la bandeja esperando
// que alguien apriete "Iniciar") no tiene etapa abierta: no se cambia el estado de
// sus documentos, no se aprueban sus secciones y no se le cursan observaciones ni
// intimaciones.
//
// El backend responde 409 igual, así que esto NO es la validación: es para que los
// botones no ofrezcan una acción que va a fallar.
// =============================================================================

const ESTADOS_SIN_INICIAR = ['BORRADOR', 'PRESENTADO'];

export function tramiteIniciado(estado: string | null | undefined): boolean {
  // Sin estado a la vista no se bloquea nada: la pantalla de documentos se abre sin
  // expediente elegido y ahí no hay trámite que iniciar.
  if (!estado) return true;
  return !ESTADOS_SIN_INICIAR.includes(estado);
}

/** Texto único del aviso, para que las dos pantallas digan lo mismo. */
export const AVISO_TRAMITE_SIN_INICIAR =
  'El trámite todavía no fue iniciado: no se puede revisar documentación ni cursar '
  + 'observaciones. Usá "Iniciar" en el encabezado del expediente para abrir la etapa '
  + 'de admisibilidad.';
